<div class="container-cycle-add-question">
  <div class="area-question-form">
    <!-- Heading -->
    <div [ngSwitch]="modalActive">
      <ng-container *ngSwitchCase="eModalType.ADD_QUESTION">
        <h1 class="standard-heading">Add a new question</h1>
      </ng-container>
      <ng-container *ngSwitchCase="eModalType.EDIT_QUESTION">
        <h1 class="standard-heading">Edit question</h1>
      </ng-container>
    </div>

    <div class="p-bottom-15">
      <div class="standard-description">Define your question</div>
    </div>
  
    <div class="frankli-form-group frankli-form-group-filled" [class.frankli-form-group-invalid]="submitted && controlText.invalid">
      <label for="text">Question</label>
      <textarea id="text" class="form-control noresize" maxlength="255" [formControl]="controlText"></textarea>
      <div class="text-right">
        <span>{{controlText.value ? controlText.value.length : 0}} / 255</span>
      </div>
      <div class="frankli-form-group-alert">
        <ng-container *ngIf="submitted && controlText.invalid">
          <div *ngIf="controlText.hasError('maxlength')">Maximum length is 255 characters</div>
          <div *ngIf="controlText.hasError('required')">Question required</div>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="modalActive === eModalType.ADD_QUESTION">
      <div class="frankli-form-group frankli-form-group-filled">
        <!-- <div class="standard-description">How should people respond to this question?</div> -->
        <label>Response type</label>

        <!-- Type -->
        <div class="area-add-question-types">
          <div class="card no-margin init-card" (click)="setQuestionType(eSurveyQuestionType.TEXT)" [class.type-selected]="controlType.value === eSurveyQuestionType.TEXT">
            <span class="fal fa-fw fa-align-left"></span>
            <span class="question-type-name">Text</span>
          </div>
          <div class="card no-margin init-card" (click)="setQuestionType(eSurveyQuestionType.LIKERT_SCALE_COMMENT)" [class.type-selected]="controlType.value === eSurveyQuestionType.LIKERT_SCALE_COMMENT">
            <span class="fal fa-fw fa-sliders-h"></span>
            <span class="question-type-name">Likert Scale</span>
          </div>
          <div class="card no-margin init-card" (click)="setQuestionType(eSurveyQuestionType.DYNAMIC_SCALE)" [class.type-selected]="controlType.value === eSurveyQuestionType.DYNAMIC_SCALE">
            <span class="fal fa-fw fa-circle-5"></span>
            <span class="question-type-name">Dynamic Scale</span>
          </div>
        </div>
      </div>  
    </ng-container>

  </div>

  <div class="area-question-preview">
    <div class="area-question-preview-heading">
      <h4 class="standard-heading">Question preview</h4>
    </div>

    <div class="area-question-preview-inner">
      <ng-container *ngIf="canCustomizeQuestionType">
        <div class="link-edit-options" [class.text-right]="!customizingScale">
          <ng-container *ngIf="!customizingScale; else templateActionStopCustomizing;">
            <a (click)="startEditOptions()">
              <span class="fal fa-fw fa-edit"></span>
            <span class="m-right-5"></span>
            <span>Edit options</span>
            </a>
          </ng-container>
          <ng-template #templateActionStopCustomizing>
            <a (click)="leaveEditOptions()">
              <span class="fal fa-fw fa-arrow-left"></span>
              <span class="m-right-5"></span>
              <span>Return to preview</span>
            </a>
          </ng-template>
        </div>
      </ng-container>

      <div>
        <h5 class="standard-heading">
          <ng-container *ngIf="controlText.value">
            <span>Q{{(controlIndex.value || 0) + 1}}.</span>
            <span class="m-right-5"></span>
            <span>{{controlText.value}}</span>
          </ng-container>
          <!-- <span>&nbsp;</span> -->
        </h5>
      </div>

      <ng-container [ngSwitch]="controlType.value">
        <ng-container *ngSwitchCase="eSurveyQuestionType.TEXT">
          <app-editor-response [disabled]="true" [columnIndent]="false" [height]="'150px'"></app-editor-response>
        </ng-container>
        <ng-container *ngSwitchCase="eSurveyQuestionType.LIKERT_SCALE">
          <app-likert-scale [disabled]="true" [columnIndent]="false"></app-likert-scale>
        </ng-container>
        <ng-container *ngSwitchCase="eSurveyQuestionType.LIKERT_SCALE_COMMENT">
          <app-likert-scale [disabled]="true" [columnIndent]="false"></app-likert-scale>
        </ng-container>
        <ng-container *ngSwitchCase="eSurveyQuestionType.DYNAMIC_SCALE">
          <ng-container *ngIf="!customizingScale; else templateCustomizingDynamicScale;">
            <app-dynamic-scale [disabled]="true" [options]="formAnswerOptions.value"></app-dynamic-scale>
          </ng-container>
          <ng-template #templateCustomizingDynamicScale>
            <app-dynamic-scale [editing]="true" [submitted]="submitted" [optionsEdit]="formAnswerOptions"></app-dynamic-scale>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <app-empty-state [height]="'200px'" [message]="'Choose a question type to see a preview here'"></app-empty-state>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div class="area-form-warnings">
    <ng-container *ngIf="(modalActive === eModalType.ADD_QUESTION) && submitted && addQuestionForm.invalid">
      <div class="frankli-form-group frankli-form-group-invalid">
        <div class="frankli-form-group-alert">
          <div *ngIf="addQuestionForm.hasError('duplicateQuestionFrankliBank')">This question already exists in our question bank. Please add it from there instead.</div>
          <div *ngIf="addQuestionForm.hasError('duplicateQuestionCompanyBank')">This question already exists in your question bank. Please add it from there instead.</div>
          <div *ngIf="addQuestionForm.hasError('duplicateQuestionCycleStep')">This question already is already asked for the current step</div>
          <div *ngIf="canCustomizeQuestionType && formAnswerOptions.invalid">There are issues with your defined options</div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="area-action-buttons">
    <app-button (onClick)="navigatePrevious()" [type]="eButtonType.GRAY_INVERTED">Cancel</app-button>
    <app-button (onClick)="navigateNext()" [type]="eButtonType.GREEN">Submit</app-button>
  </div>
</div>